import { useStaticQuery } from 'gatsby';
var useSiteMetadata = function useSiteMetadata() {
    var _useStaticQuery = useStaticQuery("1182626261"), site = _useStaticQuery.site;
    return site.siteMetadata;
};
export default useSiteMetadata;
